import styled from 'styled-components'

const FlexContainer = styled.div`
    display: flex;
    ${props => props.scroll && `overflow-y: auto;`}
    ${props => props.zIndex && `z-index: ${props.zIndex};`}
    ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
    ${props => props.maxHeight && `max-height: ${props.maxHeight};`}
    ${props => props.minWidth && `min-width: ${props.minWidth};`}
    ${props => props.height && `height: ${props.height};`}
    ${props => props.margin && `margin: ${props.margin};`}
    ${props => props.width && `width: ${props.width};`}
    ${props => props.widthChildren && `> div {width: ${props.widthChildren};}`}
    ${props => props.paddingChildren && `> div {padding: ${props.paddingChildren};}`}
    ${props => props.flow && `flex-flow: ${props.flow };`}
    ${props => props.flex && `flex: ${props.flex };`}
    ${props => props.fullSize && `width:100%; height:100%;`}
    ${props => props.justify && `justify-content: ${props.justify };`}
    ${props => props.align && `align-items: ${props.align };`}
    ${props => props.backgroundColor && `background-color: ${props.backgroundColor};`}
    ${props => props.background && `background: ${props.background};`}
    ${props => props.color && `color: ${props.color ? props.color : props.theme.text };`}
    ${props => props.padding && `padding: ${props.padding };`}
    ${props => props.border && `border: ${props.border };`}
    ${props => props.position && `position: ${props.position};`}
    ${props => props.fontSize && `*{font-size: ${props.fontSize};}`}
    ${props => props.centerColumn && `flex-flow: column;align-items: center;justify-content: center;`}
    ${props => props.center && `align-items: center;justify-content: center;`}
    ${props => props.boxShadow && `box-shadow: ${props.boxShadow};`}
`

export default FlexContainer